/**
 * @file ServiceErrorsPage.jsx
 * @description SERVICE department — Errors (from the field).
 *
 * Device-reported + computed alarms, service lens.
 *
 * This file belongs to the SERVICE department. Departments never share page
 * files: each department's top-bar header mounts its OWN file (this one), so
 * a change for SERVICE is made HERE and can never leak into another
 * department's screens. The shared engine underneath (AlarmsPage) and the backend
 * stay common — only the department-facing page is departmental. Route access
 * is department-gated in utils/permissions.js: only SERVICE users (and the
 * super admin) can open it.
 */
import React from 'react';
import AlarmsPage from '../AlarmsPage';

// The service lens: no severity, no manual close — Active while the machine
// still has it, Solved once it went away.
const ServiceErrorsPage = () => (<AlarmsPage variant="service" />);

export default ServiceErrorsPage;
